module.exports = __webpack_public_path__ + "static/transaction_fee_management1@2x-295fa94f1ff452b06d46d9074db3e138.png";